import { debounce, escapaHtml } from "../utils";
import { client, getGeoCoords } from "./nucleo";
import { guardarHistorial, borrarResultadoHistorial } from "./historial";

/* ============================================
   🔍 MODAL DE BÚSQUEDA UNIFICADO
============================================ */

window.abrirModalBusqueda = () => {
    const modal = document.getElementById('modal-busqueda');
    const overlay = document.getElementById('modal-busqueda-overlay');
    if (!modal) return;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    overlay?.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
        const input = document.getElementById('modal-busqueda-input');
        if (input) input.focus();
    }, 50);
    mbCargarHistorial();
    mbCargarPopular();
};

window.cerrarModalBusqueda = () => {
    const modal = document.getElementById('modal-busqueda');
    const overlay = document.getElementById('modal-busqueda-overlay');
    if (!modal) return;
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    overlay?.classList.add('hidden');
    document.body.style.overflow = '';
    const input = document.getElementById('modal-busqueda-input');
    if (input) { input.value = ''; }
    document.getElementById('modal-busqueda-resultados')?.classList.add('hidden');
    document.getElementById('modal-busqueda-inicio')?.classList.remove('hidden');
    document.getElementById('modal-busqueda-clear')?.classList.add('hidden');
};

window.mbLimpiarInput = () => {
    const input = document.getElementById('modal-busqueda-input');
    if (input) { input.value = ''; input.focus(); }
    document.getElementById('modal-busqueda-clear')?.classList.add('hidden');
    document.getElementById('modal-busqueda-resultados')?.classList.add('hidden');
    document.getElementById('modal-busqueda-inicio')?.classList.remove('hidden');
};

window.mbAbrirFiltros = () => {
    const panel = document.getElementById('panel-filtros-busqueda');
    if (!panel) return;
    panel.classList.remove('hidden');
    panel.classList.add('flex');
};

window.mbCerrarFiltros = () => {
    const panel = document.getElementById('panel-filtros-busqueda');
    if (!panel) return;
    panel.classList.add('hidden');
    panel.classList.remove('flex');
};

window.mbActualizarSlider = () => {
    const slider = document.getElementById('filtro-radio-min');
    const label  = document.getElementById('filtro-radio-label');
    if (slider && label) label.textContent = slider.value + 'km';
};

window.mbLimpiarFiltros = () => {
    document.querySelectorAll('.filtro-cb').forEach(cb => cb.checked = false);
    const slider = document.getElementById('filtro-radio-min');
    if (slider) { slider.value = 15; mbActualizarSlider(); }
    const prov = document.getElementById('filtro-provincia');
    if (prov) prov.value = '';
};

let _mbContarTimer = null;
window.mbContarFiltros = () => {
    clearTimeout(_mbContarTimer);
    _mbContarTimer = setTimeout(async () => {
        const btn = document.getElementById('btn-ver-resultados');
        if (!btn) return;

        const domicilio  = document.getElementById('filtro-domicilio')?.checked;
        const recogida   = document.getElementById('filtro-recogida')?.checked;
        const cerca      = document.getElementById('filtro-cerca')?.checked;
        const radio      = document.getElementById('filtro-radio')?.checked;
        const radioKm    = parseInt(document.getElementById('filtro-radio-min')?.value || 0);
        const provincia  = document.getElementById('filtro-provincia')?.value || '';
        const indep      = document.getElementById('filtro-tienda-independiente')?.checked;
        const mercado    = document.getElementById('filtro-puesto-mercado')?.checked;
        const tipoTienda = indep && !mercado ? 'Tienda independiente' : mercado && !indep ? 'Puesto en mercado o plaza' : '';

        const datos = JSON.parse(localStorage.getItem('opcionesEntrega') || '{"tienda":0,"domicilio":1}');
        if (domicilio) datos.domicilio = 1;
        if (recogida)  datos.tienda   = 1;

        btn.textContent = 'Calculando…';

        try {
            const geo = await getGeoCoords().catch(() => null);
            const params = new URLSearchParams({
                tienda:    datos.tienda,
                domicilio: datos.domicilio,
                cp:        localStorage.getItem('mt_cp') || '',
                genero:    window.currentGeneroFilter || '',
                count_only: 1,
                ...(geo          ? { lat: geo.lat, lng: geo.lng } : {}),
                ...(provincia    ? { provincia_filtro: provincia } : {}),
                ...(tipoTienda   ? { tipo_tienda_filtro: tipoTienda } : {}),
                ...(cerca        ? { max_distancia: 2000 } : {}),
                ...(radio        ? { max_distancia: radioKm * 1000 } : {}),
            });

            const res = await fetch(`/mercados/filterNav?${params}`, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!res.ok) throw new Error();
            const data = await res.json();
            const n = data.count ?? (data.html ? (data.html.match(/tienda-home-card/g) || []).length : '?');
            btn.textContent = `Ver resultados (${n})`;
        } catch (_) {
            btn.textContent = 'Ver resultados';
        }
    }, 400);
};

window.mbAplicarFiltros = () => {
    const domicilio  = document.getElementById('filtro-domicilio')?.checked;
    const recogida   = document.getElementById('filtro-recogida')?.checked;
    const cerca      = document.getElementById('filtro-cerca')?.checked;
    const radio      = document.getElementById('filtro-radio')?.checked;
    const radioKm    = parseInt(document.getElementById('filtro-radio-min')?.value || 0);
    const provincia  = document.getElementById('filtro-provincia')?.value || '';
    const tipoTienda = (() => {
        const indep   = document.getElementById('filtro-tienda-independiente')?.checked;
        const mercado = document.getElementById('filtro-puesto-mercado')?.checked;
        if (indep && !mercado) return 'Tienda independiente';
        if (mercado && !indep) return 'Puesto en mercado o plaza';
        return '';
    })();

    mbCerrarFiltros();

    // Aplicar al filterNav existente
    const datos = JSON.parse(localStorage.getItem('opcionesEntrega') || '{"tienda":0,"domicilio":1}');
    if (domicilio) datos.domicilio = 1;
    if (recogida)  datos.tienda   = 1;

    getGeoCoords().then(geo => {
        const params = {
            tienda:    datos.tienda,
            domicilio: datos.domicilio,
            cp:        localStorage.getItem('mt_cp'),
            genero:    window.currentGeneroFilter || '',
            ...(geo ? { lat: geo.lat, lng: geo.lng } : {}),
            ...(provincia  ? { provincia_filtro: provincia } : {}),
            ...(tipoTienda ? { tipo_tienda_filtro: tipoTienda } : {}),
            ...(cerca      ? { max_distancia: 2000 } : {}),
            ...(radio      ? { max_distancia: radioKm * 1000 } : {}),
        };
        $.ajax({
            url: '/mercados/filterNav',
            type: 'GET',
            dataType: 'json',
            data: params,
            success: function(response) {
                const contenedor = $('.content-index-in').length ? $('.content-index-in') : $('.bg-white-filter').first();
                if (contenedor.length) contenedor.html(response.html);
                if (typeof window.initDestacadosCarousel === 'function') window.initDestacadosCarousel();
            }
        });
    });
};

window.mbBuscarCategoria = (genero) => {
    cerrarModalBusqueda();
    if (typeof window.filtrarPorGenero === 'function') {
        window.filtrarPorGenero(genero);
    } else {
        window.location.href = `/?genero=${encodeURIComponent(genero)}`;
    }
};

window.mbLimpiarHistorial = async () => {
    try {
        await fetch('/delete-search-historial-all', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
            }
        });
    } catch (_) {}
    document.getElementById('mb-historial-list').innerHTML = '';
    document.getElementById('mb-historial-empty')?.classList.remove('hidden');
    document.getElementById('mb-historial-section')?.querySelector('button')?.classList.add('hidden');
};

async function mbCargarHistorial() {
    const list = document.getElementById('mb-historial-list');
    const empty = document.getElementById('mb-historial-empty');
    const section = document.getElementById('mb-historial-section');
    if (!list) return;

    // Invitado: sin usuario no hay historial, evitar el 401 del fetch
    if (!document.getElementById('user_id')?.value?.trim()) {
        section?.classList.add('hidden');
        return;
    }

    try {
        const res = await fetch('/search-historial');
        list.innerHTML = '';

        // 401 = guest, treat as empty (not an error)
        if (res.status === 401) {
            section?.classList.add('hidden');
            return;
        }

        const data = await res.json();

        if (!data.success || !data.data.length) {
            empty?.classList.remove('hidden');
            section?.classList.remove('hidden');
            return;
        }

        empty?.classList.add('hidden');
        section?.classList.remove('hidden');

        data.data.slice(0, 5).forEach(hit => {
            const li = document.createElement('li');
            li.className = 'flex items-center justify-between py-1.5 gap-2';
            li.innerHTML = `
                <button class="flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900 text-left flex-1 min-w-0" onclick="mbEjecutarBusqueda(${escapaHtml(JSON.stringify(hit.query))})">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-gray-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    <span class="truncate">${escapaHtml(hit.query)}</span>
                </button>
                <button class="text-gray-400 hover:text-gray-600 shrink-0 p-1" onclick="mbBorrarHistorial(${hit.id})">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>`;
            list.appendChild(li);
        });
    } catch (_) {
        empty?.classList.remove('hidden');
    }
}

window.mbBorrarHistorial = async (id) => {
    await borrarResultadoHistorial(id);
    mbCargarHistorial();
};

async function mbCargarPopular() {
    const grid = document.getElementById('mb-popular-grid');
    const gridProductos = document.getElementById('mb-popular-productos-grid');
    const section = document.getElementById('mb-popular-section');
    if (!grid) return;

    let tiendasOk = false;
    let productosOk = false;

    // ── Tiendas (fila 1) ──────────────────────────────────────────
    try {
        const res = await fetch('/filtrar-tiendas-home?filtro_tipo=&filtro_genero=&filtro_plaza=&limit=3', {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (res.ok) {
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const cards = Array.from(doc.querySelectorAll('a.tienda-home-card')).slice(0, 3);

            if (cards.length) {
                grid.innerHTML = '';
                cards.forEach(card => {
                    const img = card.querySelector('img');
                    const nombre = card.querySelector('.tienda-home-nombre, .tarjeta-negocio-nombre, h3');
                    const ratingPill = card.querySelector('.tarjeta-negocio-pill');
                    const href = card.getAttribute('href') || '#';
                    const imgSrc = img?.getAttribute('src') || '';
                    const nombreTxt = nombre?.textContent?.trim() || '';
                    const ratingTxt = ratingPill?.textContent?.trim() || '';

                    const col = document.createElement('a');
                    col.href = href;
                    col.className = 'flex flex-col rounded-xl overflow-hidden border border-gray-100 shadow-md hover:shadow-lg transition group';
                    col.innerHTML = `
                        <div class="relative w-full" style="padding-bottom:75%;">
                            <img src="${escapaHtml(imgSrc)}" alt="${escapaHtml(nombreTxt)}"
                                 class="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-200">
                            ${ratingTxt ? `<span class="absolute top-1.5 left-1.5 bg-white/90 text-gray-700 text-[10px] font-semibold rounded-full px-1.5 py-0.5 flex items-center gap-0.5">⭐ ${escapaHtml(ratingTxt)}</span>` : ''}
                        </div>
                        <div class="px-2 py-1.5 bg-white">
                            <p class="text-xs font-medium text-gray-800 leading-tight line-clamp-2">${escapaHtml(nombreTxt)}</p>
                        </div>`;
                    grid.appendChild(col);
                });
                tiendasOk = true;
            }
        }
    } catch (_) {}

    // ── Productos (fila 2) via Algolia ────────────────────────────
    if (gridProductos) {
        try {
            const results = await client.search({
                requests: [{ indexName: 'products_index', query: '', hitsPerPage: 3 }]
            });
            const hits = results?.results?.[0]?.hits || [];
            if (hits.length) {
                gridProductos.innerHTML = '';
                hits.forEach(hit => {
                    const imgSrc = hit.imagen || (hit.imagenes ? `/storage/uploads/${hit.imagenes.split(',')[0]}` : '/images/no_image.jpg');
                    const nombre = hit.name || hit.nombre || '';
                    const precio = hit.precio ? `${parseFloat(hit.precio).toFixed(2)} €` : '';
                    const mercadoId = hit.mercado_id || '';
                    const col = document.createElement('div');
                    col.style.cursor = 'pointer';
                    col.onclick = () => { if (window.modalProducto) window.modalProducto(mercadoId, hit.objectID); };
                    col.className = 'flex flex-col rounded-xl overflow-hidden border border-gray-100 shadow-md hover:shadow-lg transition group';
                    col.innerHTML = `
                        <div class="relative w-full" style="padding-bottom:75%;">
                            <img src="${escapaHtml(imgSrc)}" alt="${escapaHtml(nombre)}"
                                 class="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition duration-200">
                        </div>
                        <div class="px-2 py-1.5 bg-white">
                            <p class="text-xs font-medium text-gray-800 leading-tight line-clamp-1">${escapaHtml(nombre)}</p>
                            ${precio ? `<p class="text-xs text-teal-600 font-semibold mt-0.5">${escapaHtml(precio)}</p>` : ''}
                        </div>`;
                    gridProductos.appendChild(col);
                });
                productosOk = true;
            }
        } catch (_) {}
    }

    if (tiendasOk || productosOk) {
        section?.classList.remove('hidden');
    } else {
        section?.classList.add('hidden');
    }
}

window.mbEjecutarBusqueda = (query) => {
    if (!query) return;
    guardarHistorial(query);
    cerrarModalBusqueda();
    window.location.href = `/search?q=${encodeURIComponent(query)}`;
};

// Wiring del input del modal
document.addEventListener('DOMContentLoaded', () => {
    const mbInput = document.getElementById('modal-busqueda-input');
    const mbClear = document.getElementById('modal-busqueda-clear');
    const mbResultados = document.getElementById('modal-busqueda-resultados');
    const mbInicio = document.getElementById('modal-busqueda-inicio');
    if (!mbInput) return;

    const debouncedMbSearch = debounce(async (q) => {
        if (!q) {
            mbResultados?.classList.add('hidden');
            mbInicio?.classList.remove('hidden');
            return;
        }
        mbResultados?.classList.remove('hidden');
        mbInicio?.classList.add('hidden');

        try {
            const response = await client.search({ requests: [
                { indexName: 'products_index', query: q, hitsPerPage: 5 },
                { indexName: 'stores_index',   query: q, hitsPerPage: 5 },
                { indexName: 'markets_index',  query: q, hitsPerPage: 5 },
            ]});

            ['markets', 'stores', 'products'].forEach((type, i) => {
                const el = document.getElementById(`mb-${type}-section`);
                if (!el) return;
                el.innerHTML = '';
                const hits = response.results[i].hits;
                if (!hits.length) return;
                hits.forEach(hit => {
                    const a = document.createElement('a');
                    a.href = type === 'products'
                        ? `/tienda/${hit.mercado_slug ?? hit.mercado_id}#prod-${hit.objectID}`
                        : `/${type === 'markets' ? 'plazas' : 'tienda'}/${hit.objectID}`;
                    a.className = 'flex items-center gap-3 py-2 hover:bg-gray-50 rounded-lg px-2 transition';
                    a.innerHTML = `
                        <div class="w-9 h-9 rounded-lg bg-gray-100 overflow-hidden shrink-0">
                            ${hit.image ? `<img src="${escapaHtml(hit.image)}" class="w-full h-full object-cover">` : ''}
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-800 truncate">${escapaHtml(hit.name || hit.nombre || '')}</p>
                            ${hit.precio ? `<p class="text-xs text-gray-400">${parseFloat(hit.precio).toFixed(2)}€</p>` : ''}
                        </div>`;
                    el.appendChild(a);
                });
            });

            const total = response.results.reduce((s, r) => s + r.hits.length, 0);
            document.getElementById('mb-no-results')?.classList.toggle('hidden', total > 0);

        } catch (_) {}
    }, 250);

    mbInput.addEventListener('input', (e) => {
        const q = e.target.value.trim();
        mbClear?.classList.toggle('hidden', !q);
        debouncedMbSearch(q);
    });

    mbInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && mbInput.value.trim()) {
            mbEjecutarBusqueda(mbInput.value.trim());
        }
        if (e.key === 'Escape') cerrarModalBusqueda();
    });
});

// Cerrar con Escape global
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const modal = document.getElementById('modal-busqueda');
        if (modal && !modal.classList.contains('hidden')) cerrarModalBusqueda();
    }
});
